import styled from "styled-components";
import colours from "../../lib/colours";

export const FilledButton = styled.button`
  font-size: 16px;
  cursor: pointer;
  height: 42px;
  padding: 10px 16px;
  background-color: ${colours.th2};
  color: ${colours.th1};
  font-weight: 600;
  border: none;
  transition: background-color 0.2s linear, color 0.2s linear;
  border-radius: 2px;
  &:hover {
    background-color: ${colours.th2d1};
  }
  &:disabled {
    background-color: ${colours.grey3};
    cursor: not-allowed;
  }
`;

export const FilledButtonAlt = styled(FilledButton)`
  background-color: ${colours.white};
  &:hover {
    background-color: ${colours.offWhite};
  }
  &:disabled {
    background-color: ${colours.white};
  }
`;

export default FilledButton;
